export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api/v1';

export const API_ENDPOINTS = {
  // Autenticación
  auth: {
    login: '/auth/login',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
    me: '/auth/me',
    profile: '/auth/profile',
    changePassword: '/auth/cambiar-contrasena',
    surveyStatus: '/auth/datos-complementarios-estado',
  },
  // Usuarios
  users: {
    list: '/users',
    create: '/users',
    update: (id: string) => `/users/${id}`,
    delete: (id: string) => `/users/${id}`,
    toggleStatus: (id: string) => `/users/${id}/toggle-status`,
    resetPassword: (id: string) => `/users/${id}/reset-password`,
    profile: '/users/profile',
    roles: '/users/roles',
  },
  // Membresías
  memberships: {
    list: '/memberships',
    create: '/memberships',
    createAdmin: '/memberships/admin',
    update: (id: string) => `/memberships/${id}`,
    delete: (id: string) => `/memberships/${id}`,
    detail: (id: string) => `/memberships/${id}`,
    me: '/memberships/me',
    bulkUpload: '/memberships/bulk-upload',
    bulkUploadDatosComplementarios: '/memberships/datos-complementarios/bulk-upload',
    datosComplementarios: (id: string) => `/memberships/${id}/datos-complementarios`,
  },
  // Dashboard
  dashboard: {
    stats: '/dashboard/stats',
  },
  // Mayordomía
  mayordomia: {
    base: '/mayordomia',
    categorias: '/mayordomia/categorias',
    categoria: (id: string) => `/mayordomia/categorias/${id}`,
    ingresos: '/mayordomia/ingresos',
    ingreso: (id: string) => `/mayordomia/ingresos/${id}`,
    gastos: '/mayordomia/gastos',
    gasto: (id: string) => `/mayordomia/gastos/${id}`,
    deudas: '/mayordomia/deudas',
    deuda: (id: string) => `/mayordomia/deudas/${id}`,
    pagoDeuda: (id: string) => `/mayordomia/deudas/${id}/pago`,
    pagarCuota: (id: string) => `/mayordomia/deudas/${id}/cuotas/pagar`,
    anularCuota: (id: string, mes: string) =>
      `/mayordomia/deudas/${id}/cuotas/${mes}`,
    estadoCuotas: '/mayordomia/deudas/cuotas',
    ajustes: '/mayordomia/ajustes',
    ajuste: (id: string) => `/mayordomia/ajustes/${id}`,
    presupuestos: '/mayordomia/presupuestos',
    presupuesto: (id: string) => `/mayordomia/presupuestos/${id}`,
    metasAhorro: '/mayordomia/metas-ahorro',
    metaAhorro: (id: string) => `/mayordomia/metas-ahorro/${id}`,
    abonoMeta: (id: string) => `/mayordomia/metas-ahorro/${id}/abono`,
    retiroMeta: (id: string) => `/mayordomia/metas-ahorro/${id}/retiro`,
    dashboard: '/mayordomia/dashboard',
    diezmo: '/mayordomia/diezmo',
    cuentas: '/mayordomia/cuentas',
    cuenta: (id: string) => `/mayordomia/cuentas/${id}`,
    recurrentesGenerar: '/mayordomia/recurrentes/generar',
    pagosDeuda: (id: string) => `/mayordomia/deudas/${id}/pagos`,
    tendencia: '/mayordomia/reporte/tendencia',
    vinculos: '/mayordomia/vinculos',
    vinculo: (otroUsuarioId: string) => `/mayordomia/vinculos/${otroUsuarioId}`,
  },
  // Ministerios
  ministries: {
    list: '/ministries',
    mine: '/ministries/mine',
    create: '/ministries',
    update: (id: string) => `/ministries/${id}`,
    delete: (id: string) => `/ministries/${id}`,
    toggleStatus: (id: string) => `/ministries/${id}/estado`,
    detail: (id: string) => `/ministries/${id}`,
    integrantes: (id: string) => `/ministries/${id}/integrantes`,
    eventos: (id: string) => `/ministries/${id}/eventos`,
    eventoDetail: (id: string) => `/eventos/${id}`,
    eventoUpdate: (id: string) => `/eventos/${id}`,
    eventoDelete: (id: string) => `/eventos/${id}`,
    asistencia: (id: string) => `/eventos/${id}/asistencia`,
    inscripciones: (id: string) => `/eventos/${id}/inscripciones`,
    cancelarInscripcion: (eventoId: string, inscripcionId: string) => `/eventos/${eventoId}/inscripciones/${inscripcionId}/cancelar`,
    movimientos: (id: string) => `/eventos/${id}/movimientos`,
    deleteMovimiento: (movimientoId: string) => `/eventos/movimientos/${movimientoId}`,
    reporteAsistencia: (id: string) => `/ministries/${id}/reporte-asistencia`,
    publicEventos: '/eventos/public',
    allEventos: '/eventos',
  },
  notifications: {
    mine: '/notificaciones/mine',
    noLeidas: '/notificaciones/mine/no-leidas',
    marcarLeida: (id: string) => `/notificaciones/${id}/leida`,
    leerTodas: '/notificaciones/leer-todas',
  },
  // Programación Semanal
  programacion: {
    list: '/programaciones-semanales',
    create: '/programaciones-semanales',
    detail: (id: string) => `/programaciones-semanales/${id}`,
    update: (id: string) => `/programaciones-semanales/${id}`,
    delete: (id: string) => `/programaciones-semanales/${id}`,
    catalogos: '/programaciones-semanales/catalogos',
    actual: '/programaciones-semanales/actual',
    asignacionesPorMinisterio: (ministerioId: string) =>
      `/programaciones-semanales/asignaciones/ministerio/${ministerioId}`,
    seguimiento: (asignacionId: string) =>
      `/programaciones-semanales/asignaciones/${asignacionId}/seguimiento`,
  },
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;